<template>
  <div class="padbox">
    <el-row :gutter="60">
      <el-col :span="12">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-divider content-position="left">签到配置</el-divider>
            <el-form
              ref="signForm"
              :model="sign"
              :rules="rules"
              class="demo-editForm"
              label-width="200px"
            >
              <el-form-item label="每天签到的积分数量:" prop="num">
                <el-input v-model="sign.num" type="number" min="0"></el-input>
              </el-form-item>
              <el-form-item label="7天签到之后增加的数量:" prop="numAdd">
                <el-input
                  v-model="sign.numAdd"
                  type="number"
                  min="0"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  style="margin-left: 33.3%"
                  @click="submitForm('signForm')"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <el-divider content-position="left">积分规则</el-divider>
            <el-form
              ref="rulesForm"
              :model="sign"
              :rules="rules"
              class="demo-editForm"
              label-width="200px"
            >
              <el-row v-for="(item, index) in membershipRules" :key="index">
                <el-col :span="18">
                  <el-form-item :label="'规则' + (index + 1) + ':'" prop="num">
                    <el-input
                      v-model="membershipRules[index].content"
                      type="textarea"
                      rows="2"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <i
                    class="el-icon-circle-plus-outline"
                    style="color: #67c23a; margin: 0 30px"
                    @click="addRule(index)"
                  ></i>
                  <i
                    class="el-icon-delete"
                    style="color: #f56c6c"
                    @click="delRule(index)"
                  ></i>
                </el-col>
              </el-row>

              <el-form-item>
                <el-button
                  type="primary"
                  style="margin-left: 33.3%"
                  @click="submitForm('rulesForm')"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>

          <el-col :span="24">
            <el-divider content-position="left">积分兑换比例</el-divider>
            <el-form
              ref="pointsForm"
              :model="rulesForm"
              :rules="rules"
              class="demo-editForm"
              label-width="200px"
            >
              <el-form-item label="一元可兑积分:" prop="points">
                <el-input
                  v-model="rulesForm.points"
                  type="number"
                  min="0"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  style="margin-left: 33.3%"
                  @click="submitForm('pointsForm')"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <el-divider content-position="left">邀请人一元可兑积分</el-divider>
            <el-form
              ref="shareForm"
              :model="rulesForm"
              :rules="rules"
              class="demo-editForm"
              label-width="200px"
            >
              <el-form-item label="一元可兑积分:" prop="sharePoints">
                <el-input
                  v-model="rulesForm.sharePoints"
                  type="number"
                  min="0"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  style="margin-left: 33.3%"
                  @click="submitForm('shareForm')"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <el-divider content-position="left"
              >用户扫达人码锁定时长</el-divider
            >
            <el-form
              ref="durationForm"
              :model="rulesForm"
              :rules="rules"
              class="demo-editForm"
              label-width="200px"
            >
              <el-form-item label="时长(小时):" prop="duration">
                <el-input
                  v-model="rulesForm.duration"
                  type="number"
                  min="0"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  style="margin-left: 33.3%"
                  @click="submitForm('durationForm')"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-divider content-position="left">提现金额配置</el-divider>
            <el-button
              style="margin-bottom: 20px; float: inline-end"
              type="primary"
              @click="setAdd()"
              >添加</el-button
            >
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              border
              stripe
            >
              <el-table-column
                label="金额"
                align="center"
                prop="money"
              ></el-table-column>
              <el-table-column
                label="操作"
                align="center"
                prop="icon"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-popconfirm
                    title="确定删除吗？"
                    @confirm="delHandle(scope.row.id)"
                  >
                    <el-button type="danger" plain slot="reference"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24">
            <el-divider content-position="left">小程序分享图</el-divider>
            <el-form
              ref="shareImageForm"
              :model="rulesForm"
              :rules="rules"
              class="demo-editForm"
              label-width="200px"
            >
              <el-form-item label="分享图:" prop="sharePoints">
                <VploadImg
                  :limit="1"
                  :type="1"
                  v-bind:file-list="rulesForm.shareUrl"
                  @submitImg="getImg"
                ></VploadImg>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('shareImageForm')"
                  style="margin-bottom: 20px; float: left"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      title="添加"
      :visible.sync="dialogVisible"
      width="800px"
      append-to-body
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        ref="moneyForm"
        :rules="rules"
        label-width="100px"
        class="demo-editForm"
      >
        <el-form-item label-width="100px" label="金额:" prop="money">
          <el-input v-model="editForm.money"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('moneyForm')"
            style="float: left"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import VploadImg from "../inc/VploadImgThree";
export default {
  name: "configuration",
  components: { VploadImg },
  data() {
    return {
      editForm: {
        money: "",
      },
      membershipRules: [],
      dialogVisible: false,
      sign: {},
      tableData: [],
      rulesForm: {
        sharePoints: 0,
        points: 0,
        shareUrl: [],
        duration: "",
      },
      rules: {
        money: [
          {
            required: true,
            message: "请输入金额",
            trigger: "blur",
          },
        ],
        num: [
          {
            required: true,
            message: "请输入每天签到的积分数量",
            trigger: "blur",
          },
        ],
        numAdd: [
          {
            required: true,
            message: "请输入7天签到之后增加的数量",
            trigger: "blur",
          },
        ],
        points: [
          {
            required: true,
            message: "请输入一元可兑积分",
            trigger: "blur",
          },
        ],
        shareUrl: [
          {
            required: true,
            message: "请上传",
            trigger: "blur",
          },
        ],
        sharePoints: [
          {
            required: true,
            message: "请输入邀请人一元可兑积分",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getsignIn();
    this.getConfig();
    this.getpointsConfig();
    this.getHourTime();
    this.getShareUrl();
  },
  methods: {
    getImg(img, add) {
      this.rulesForm.shareUrl = add == 0 ? [] : [{ url: img }];
    },
    handleClose() {
      this.dialogVisible = false;
    },
    addRule(index) {
      this.membershipRules.splice(index + 1, 0, { content: null });
    },
    delRule(index) {
      this.membershipRules.splice(index, 1);
    },
    setAdd() {
      this.editForm.money = "";
      this.dialogVisible = true;
    },
    getConfig() {
      this.$axios.post("/admin/rechargeAmount/getList", {}).then((res) => {
        this.tableData = res.data;
      });
    },
    delHandle(id) {
      this.$axios
        .post("/admin/rechargeAmount/del", {
          id: id,
        })
        .then((res) => {
          this.getConfig();
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {},
          });
        });
    },
    getsignIn() {
      this.$axios.get("/admin/signInConfiguration/getList").then((res) => {
        this.sign = res.data[0];
        this.membershipRules = this.sign.membershipRules
          ? JSON.parse(this.sign.membershipRules)
          : [{ content: null }];
      });
    },

    getShareUrl() {
      this.$axios.get("/admin/sysConfig/getShareUrl").then((res) => {
        this.rulesForm.shareUrl = [{ url: res.msg }];
      });
    },

    getpointsConfig() {
      this.$axios.get("/admin/sysConfig/getList").then((res) => {
        this.rulesForm.sharePoints = res.data[3].sharePoints;
        this.rulesForm.points = res.data[2].points;
        this.rulesForm.shareUrl = res.data[4].shareUrl
          ? [{ url: res.data[4].shareUrl }]
          : [];
      });
    },
    getHourTime() {
      this.$axios.get("/admin/sysConfig/getHourTime").then((res) => {
        this.rulesForm.duration = res.data;
      });
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "signForm") {
            var obj = {
              num: this.sign.num,
              id: this.sign.id,
              numAdd: this.sign.numAdd,
            };

            this.$axios
              .post("/admin/signInConfiguration/upd", obj)
              .then((res) => {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
              });
          } else if (formName == "moneyForm") {
            var obj = {
              money: this.editForm.money,
            };

            this.$axios.post("/admin/rechargeAmount/add", obj).then((res) => {
              this.dialogVisible = false;
              this.getConfig();
              this.$message({
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
          } else if (formName == "rulesForm") {
            var obj = {
              id: this.sign.id,
              membershipRules: JSON.stringify(this.membershipRules),
            };

            this.$axios
              .post("/admin/signInConfiguration/upd", obj)
              .then((res) => {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
              });
          } else if (formName == "pointsForm") {
            var obj = {
              points: this.rulesForm.points,
            };

            this.$axios
              .post("/admin/sysConfig/updProportion", obj)
              .then((res) => {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
              });
          } else if (formName == "shareForm") {
            var obj = {
              sharePoints: this.rulesForm.sharePoints,
            };

            this.$axios
              .post("/admin/sysConfig/updProportion2", obj)
              .then((res) => {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
              });
          } else if (formName == "shareImageForm") {
            var obj = {
              shareUrl: this.rulesForm.shareUrl[0].url,
            };

            this.$axios
              .get("/admin/sysConfig/updShareUrl", { params: obj })
              .then((res) => {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
              });
          } else if (formName == "durationForm") {
            var obj = {
              hourTime: this.rulesForm.duration,
            };
            this.$axios
              .get("/admin/sysConfig/updHourTime", { params: obj })
              .then((res) => {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
              });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.padbox {
  background: #fff;
  width: 100%;
  height: calc(100% - 120px);
  padding: 20px;
}
</style>
